import { CoffeeAppType } from "../types/app";

export function getAppType(): CoffeeAppType {
  if (typeof window === "undefined") return CoffeeAppType.CRM;
  const host = window.location.hostname;
  const subdomain = host.split(".")[0];

  if (subdomain === "crmgrader") {
    return CoffeeAppType.CRM_GRADER;
  } else {
    return CoffeeAppType.CRM;
  }
}
